export function DoubleConnectionLine(props) {
  const { className, stroke, ...rest } = props;
  return (
    <svg width='10' height='270' viewBox='0 0 10 270' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path d='M0.5 156.5H8.5' stroke='#5C5C6E' />
      <path d='M1 269H5C7.20914 269 9 267.209 9 265L9 4.99999C9 2.79085 7.20914 0.999991 5 0.999991H1' stroke={stroke} />
    </svg>
  );
}
